import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";

export type QuoteRequestLineOverthicknessDto = ClientInferResponseBody<
  typeof contract.quoteRequestLines.findOverthickness,
  200
>;

export const fetchQuoteRequestLineOverthickness = async (
  id: string,
): Promise<QuoteRequestLineOverthicknessDto | null> => {
  const response = await api.quoteRequestLines.findOverthickness.query({ params: { id } });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
